import { get } from 'lodash';
const _processProducts = (products) => {
  if (products.length < 1) {
    return [];
  } else {
    const re = products.reduce((pre, now) => {
      const { productUuid, productName, sku } = now;
      const flashSaleDiscounts = get(now, 'flashSaleDiscounts') || [];
      //  const len = flashSaleDiscounts.length;
      if (flashSaleDiscounts.length < 1) {
        return pre;
      } else {
        const _flat = flashSaleDiscounts.map((i, index, __self) => {
          if (index === 0) {
            const len = __self.length;
            return { ...i, productUuid, productName, sku, rowSpan: len };
          }
          return { ...i, productUuid, productName, sku, rowSpan: 0 };
        });

        return [...pre, ..._flat];
      }
    }, []);
    return re;
  }
};
const processFlashSaleProducts = (data) => {
  //   const { products }=data;
  const re = data.map((i) => {
    const { products } = i;

    const _products = _processProducts(products || []);
    return { ...i, products: _products };
  });
  return re;
};
export { processFlashSaleProducts };
